import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO + Open Graph meta tags.
 * Falls back gracefully if any field is missing.
 */
export default function Seo({
  title,
  description,
  image,
  url,
  type = "website",
}) {
  const fullTitle = title
    ? `${title} — B. Ruff Writes`
    : "B. Ruff Writes — Barbara Ruffing, Author";
  const desc =
    description ||
    "Barbara Ruffing — author of her first children's book, plus poems and articles to encourage individuals in their faith.";

  // Build absolute canonical URL from current location at runtime
  const canonical =
    url ||
    (typeof window !== "undefined"
      ? `${window.location.origin}${window.location.pathname}`
      : "");

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {canonical && <link rel="canonical" href={canonical} />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {canonical && <meta property="og:url" content={canonical} />}
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
